export const supportedLang = ['ja', 'en'] as const;
/**
 * サポートする言語
 */
export type supportedLang = (typeof supportedLang)[number];
